import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactSVG } from 'react-svg';
import { history, store } from '@/redux/store';
import { GOOGLE_CLIENT_ID, initSentry } from '@/config';
import { px2remTransformer, StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import { antdTheme } from '@/theme';
import { App } from '@/app';
import svgIcons from '@/assets/sprite.svg';
import '@/styles/index.sass';
import '@/i18n';

// Initialize Sentry as early as possible
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const px2rem = px2remTransformer({
  rootValue: 10,
  mediaQuery: true,
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ConfigProvider theme={antdTheme}>
            <StyleProvider transformers={[px2rem]}>
              <App />
            </StyleProvider>
          </ConfigProvider>
        </GoogleOAuthProvider>
      </HistoryRouter>
    </Provider>
    <ReactSVG src={svgIcons} />
  </React.StrictMode>,
);
